module.exports = __webpack_public_path__ + "static/img/ET.86784223.png";